import React from "react";
import { useCanRemoveFinancialConnection } from "@hooks/permissions/useCanRemoveFinancialConnection";
import { PlaidConnectionWithAccounts } from "@common/types/plaidConnection";
import { Menu } from "@design-system/Menu/Menu.lib";
import { EntitySettingsPages } from "@components/settings/constants";
import { getEntityPaneKey } from "../../../settings/lib";
import { useSettings } from "../../../settings/SettingsProvider";

interface PlaidConnectionSettingsDropdownProps {
    busy?: boolean;
    connection: PlaidConnectionWithAccounts;
    onRemove(): void;
}

export const ExternalConnectionSettingsDropdown: React.FC<
    PlaidConnectionSettingsDropdownProps
> = ({ busy, connection, onRemove }) => {
    const { open } = useSettings();
    const firstAccount = connection.accounts[0];
    const firstAccountEntity = firstAccount?.financialAccount?.entity;
    const canRemoveConnection = useCanRemoveFinancialConnection(connection);

    return (
        <Menu.More disabled={busy}>
            {firstAccount && firstAccountEntity && (
                <Menu.Item
                    onClick={() =>
                        open([
                            getEntityPaneKey(
                                EntitySettingsPages.SETTINGS,
                                firstAccountEntity.id,
                            ),
                            firstAccount.id.toString(),
                        ])
                    }
                >
                    Settings
                </Menu.Item>
            )}
            {canRemoveConnection && (
                <Menu.Item onClick={onRemove} destructive>
                    Remove integration
                </Menu.Item>
            )}
        </Menu.More>
    );
};
